<template>
    <section id="content">

        <div class="content-wrap">

            <div class="container clearfix">

                <div class="col_full">
                    <div class="panel card-default nobottommargin">
                        <div class="card-body" style="padding: 40px;">
                            <form @keyup.enter.native="submitForm()">
                                <h3>Retrieve Policy & Certificate</h3>

                                <div v-if="!hash">
                                    <div class="col_full">
                                        <label for="login-form-username">Certificate Number</label>
                                        <input id="login-form-username" v-model="cert.cert" class="form-control"
                                               autocomplete="off">
                                    </div>

                                    <div class="col_full">
                                        <br><strong>Or</strong>, if you don't know your Certificate Number:<br><br>
                                        <label for="login-form-username">Social Security Number (SSN)</label>
                                        <input id="login-form-username" v-model="cert.ssn" class="form-control"
                                               autocomplete="off">
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <label>Date of Birth (DOB)</label>
                                            <select class="form-control" v-model="cert.dob_month">
                                                <option value="01">January</option>
                                                <option value="02">February</option>
                                                <option value="03">March</option>
                                                <option value="04">April</option>
                                                <option value="05">May</option>
                                                <option value="06">June</option>
                                                <option value="07">July</option>
                                                <option value="08">August</option>
                                                <option value="09">September</option>
                                                <option value="10">October</option>
                                                <option value="11">November</option>
                                                <option value="12">December</option>
                                            </select>
                                        </div>
                                        <div class="col">
                                            <label>Day</label>
                                            <select class="form-control" v-model="cert.dob_day">
                                                <option value="01">01</option>
                                                <option value="02">02</option>
                                                <option value="03">03</option>
                                                <option value="04">04</option>
                                                <option value="05">05</option>
                                                <option value="06">06</option>
                                                <option value="07">07</option>
                                                <option value="08">08</option>
                                                <option value="09">09</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="31">31</option>
                                            </select>
                                        </div>
                                        <div class="col">
                                            <label>Year</label>
                                            <select class="form-control" v-model="cert.dob_year">
                                                <option v-for="year in years" :value="year">{{ year }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div v-if="loginError" class="alert alert-danger">{{loginError.msg}}</div>
                                    <div class="col_full nobottommargin" style="margin-top: 50px;">
                                        <button class="button button-3d button-black nomargin" id="login-form-submit" type="button"
                                                name="login-form-submit" @click="submitForm()" v-if="!processing">Retrieve
                                        </button>
                                        <div v-if="processing">Processing</div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div v-if="downloadLink">
                                        <p>Download the certificate below by clicking on 'Download Certificate'.</p>

                                        <b-button size="lg" variant="primary" :href="downloadLink"><font-awesome-icon icon="file" class="mr-3"></font-awesome-icon>Download Certificate</b-button>
                                    </div>

                                    <div v-else>
                                        <div v-if="attempts <= 10">
                                            <p><b-spinner small></b-spinner>&nbsp; Your member certificate has been requested.  This process may take a few minutes.  Please wait. ({{attempts}})</p>

                                            <b-button size="lg" variant="primary" :disabled="!downloadLink">
                                                <font-awesome-icon icon="file" class="mr-3"></font-awesome-icon>Download Certificate
                                            </b-button>
                                        </div>
                                        <div v-else>
                                            <p><font-awesome-icon icon="ban" class="mr-2"/>The certificate failed to generate.  Please try again or contact us for assistance.</p>
                                        </div>
                                    </div>
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </section>

</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import axios from "axios";
    import config from '@/config/config.js';

    export default {
        name: 'Login',
        data () {
            return {
                cert: {},
                attempts: 0,
                hash: null,
                downloadLink: null
            }
        },
        computed: {
            ...mapGetters(['currentUser', 'processing', 'loginError']),

            years() {
                const year = new Date().getFullYear()
                return Array.from({length: year - 1900}, (value, index) => 1901 + index)
            }
        },
        methods: {
            submitForm () {
                axios.post(config.apiUrl() + 'member/certificate/lookup', {...this.cert, template: 'cert'}).then(response => {
                    this.hash = response.data.hash;
                    this.checkCert();
                });
            },

            checkCert() {
                if (this.attempts++ <= 10) {
                    axios.get(config.apiUrl() + 'member/certificate/' + this.hash).then(response => {
                        this.downloadLink = config.downloadUrl() + 'certs/' + this.hash + '.pdf';
                    }, err => {
                        setTimeout(() => {
                            this.checkCert();
                        }, 30000);
                    });
                }
            }
        },
        watch: {
            currentUser (val) {
                if (val && val.id) {
                    switch (true) {
                        case val.user_types.producer.id !== undefined:
                            this.$router.push('/dashboard/producer')
                            break
                        case val.user_types.general_agents.id !== undefined:
                            this.$router.push('/dashboard/general-agent')
                            break
                        default:
                            this.$router.push('/dashboard')
                            break
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
